import { jsxs as r, jsx as i } from "react/jsx-runtime";
import { ToggleButton as s } from "../ToggleButton/index.js";
import { getRenderedPages as l } from "./tools.js";
import { ChevronLeftIcon as f } from "../Icons/basic/ChevronLeftIcon.js";
import { ChevronRightIcon as v } from "../Icons/basic/ChevronRightIcon.js";
const b = ({
  currentPage: e,
  setCurrentPage: n,
  disabled: t,
  totalPages: m
}) => {
  const c = l(e, m);
  return /* @__PURE__ */ r("div", { className: "jm-flex jm-w-fit jm-gap-2", children: [
    /* @__PURE__ */ i(
      s,
      {
        size: "condensed",
        icon: /* @__PURE__ */ i(f, {}),
        label: "prevPage",
        active: !1,
        disabled: t || e === 1,
        onClick: () => {
          n((o) => o - 1);
        }
      }
    ),
    c.map((o, d) => /* @__PURE__ */ i(
      s,
      {
        size: "condensed",
        text: o.toString(),
        active: o === e,
        disabled: t || o === "...",
        onClick: () => {
          typeof o != "string" && n(o);
        }
      },
      `${d}_${o}`
    )),
    /* @__PURE__ */ i(
      s,
      {
        size: "condensed",
        icon: /* @__PURE__ */ i(v, {}),
        label: "nextPage",
        active: !1,
        disabled: t || e === m,
        onClick: () => {
          n((o) => o + 1);
        }
      }
    )
  ] });
};
export {
  b as Pagination
};
//# sourceMappingURL=index.js.map
